import type { ReactNode } from "react"
import { createContext, useEffect, useState } from "react"

interface ThemeModeContext { mode: 'light' | 'dark' | 'system', setMode:any }

export const ThemeModeContext = createContext<ThemeModeContext>({ mode: 'system', setMode:() => {} });


interface ThemeModeProps { children: ReactNode}

export const ThemeModeProvider = (props:ThemeModeProps) => {

    const [currentMode, setCurrentMode] = useState< 'light' | 'dark' | 'system' >(window.matchMedia('(prefers-color-scheme: dark)')['matches']?'dark':'light')

    useEffect( () => {
        document.body.className = currentMode
    }, [])

    const setMode = (mode:'light'|'dark'|'system') => {
        setCurrentMode(mode)
        document.body.className = mode
    }
    
    return (
        <ThemeModeContext.Provider value={{mode: currentMode, setMode:setMode}}>
            {props.children}
        </ThemeModeContext.Provider>
    )
}